import findIndex from 'lodash/findIndex';

export default (state = [], action = {}) => {
  switch(action.type) {
    case 'FETCH_TODOS':
      return action.data;
    case 'EDIT_TODO':
      const index = findIndex(
        state,
        { todo_id: action.payload.todo_id }
      );
      if (index >= 0) {
        const newState = [
          ...state.slice(0, index),
          action.payload,
          ...state.slice(index + 1)
        ]
        return newState;
      }
      return state;
    case 'CREATE_TODO':
      return [
        ...state,
        action.payload
      ]
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/todos.js